import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "@core/components/header/header.component";
import { FooterComponent } from "@core/components/footer/footer.component";
import { DataModule } from "./data/data.module";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { StepWizardComponent } from "./components/step-wizard/step-wizard.component";
import { EnrollmentBannerComponent } from "./components/enrollment-banner/enrollment-banner.component";
import { SummaryComponent } from "./components/summary/summary.component";
import { PlanItemComponent } from "./components/plan-item/plan-item.component";
import { BenefitsModalComponent } from "./components/benefits-modal/benefits-modal.component";
import { BenefitsSelectionModalComponent } from "./components/benefits-selection-modal/benefits-selection-modal.component";
import { PcpSearchComponent } from "./components/pcp-search/pcp-search.component";
import { PcpItemComponent as PcpItemComponentV2 } from "./components/pcp-item/v2/pcp-item.component";
import { PcpItemComponent as PcpItemComponentV3 } from "./components/pcp-item/v3/pcp-item.component";
import { PcpSelectionModalComponent } from "./components/pcp-selection-modal/pcp-selection-modal.component";
import { CountySelectionModalComponent } from "./components/county-selection-modal/county-selection-modal.component";
import { LoginComponent } from "./components/login/login.component";
import { MaintenanceComponent } from "./components/maintenance/maintenance.component";
import { NgxPaginationModule } from "ngx-pagination";
import { PlanSummaryModalComponent } from "./components/plan-summary-modal/plan-summary-modal.component";
import { ArrayHasObjectPipe } from "@core/pipes/array-has-object.pipe";
import { HelpModalComponent } from "./components/help-modal/help-modal.component";
import { ApiErrorModalComponent } from "./components/api-error-modal/api-error-modal.component";
import { ConsentModalComponent } from "./components/consent-modal/consent-modal.component";
import { LANGS_CHINESE, LANGS_ENGLISH, LANGS_SPANISH, LOCAL_STORAGE_LANG_KEY } from "@core/constants/app";
import { FeatureFlagDirective } from "@core/directives/feature-flag.directive";
import { AutocompleteOffDirective } from "@core/directives/autocomplete-off.directive";
import { LanguageSelectionComponent } from "@core/components/language-selection/language-selection.component";

const COMPONENTS = [
    HeaderComponent,
    FooterComponent,
    LanguageSelectionComponent,
    PlanItemComponent,
    BenefitsModalComponent,
    ConsentModalComponent,
    PlanSummaryModalComponent,
    SummaryComponent,
    StepWizardComponent,
    EnrollmentBannerComponent,
    BenefitsSelectionModalComponent,
    PcpSearchComponent,
    PcpItemComponentV2,
    PcpItemComponentV3,
    PcpSelectionModalComponent,
    CountySelectionModalComponent,
    LoginComponent,
    MaintenanceComponent,
    HelpModalComponent,
    ApiErrorModalComponent,
    FeatureFlagDirective,
    AutocompleteOffDirective,
];

const PIPES = [ArrayHasObjectPipe];

@NgModule({
    declarations: [...COMPONENTS, ...PIPES],
    exports: [...COMPONENTS, ...PIPES],
    imports: [
        CommonModule,
        DataModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        FontAwesomeModule,
        NgxPaginationModule,
    ],
    providers: [provideNgxMask()],
})
export class CoreModule {
    constructor(private translateService: TranslateService) {
        const languages = [LANGS_ENGLISH, LANGS_SPANISH, LANGS_CHINESE];
        this.translateService.addLangs(languages);
        this.translateService.use(localStorage.getItem(LOCAL_STORAGE_LANG_KEY) || LANGS_ENGLISH);
        this.translateService.setDefaultLang(LANGS_ENGLISH);
    }
}
